export const JOIN_IN_SECS = 30;
